import { IconProps } from "../types";

// Helper function to apply size prop
export const applySizeToProps = (
  props: IconProps
): IconProps => {
  const { size, style, fill, ...rest } = props;

  const withColor: IconProps = {
    ...rest,
    fill: fill ?? "currentColor",
    style,
  };

  if (size === undefined) {
    return withColor;
  }

  return {
    ...withColor,
    style: {
      ...style,
      width: size,
      height: size,
    },
  };
};